import React, { Fragment } from 'react'
import { Typography } from '@klarna/bubble-ui'
import styles from './PaymentMethodDetails.css'
import { InvoicePaymentDetailsProps, PayByCardPaymentDetailsProps } from '../../types'

const InvoicePaymentDetails: React.FC<InvoicePaymentDetailsProps | PayByCardPaymentDetailsProps> = ({
  totalTranslation = '',
  totalAmount = '',
  feeAmount = '',
  feeTranslation = '',
  isFeeGreaterThanZero = false
}) => (
  <Fragment>
    <style>{styles}</style>
    <div className="details-container">
      {feeAmount && isFeeGreaterThanZero ? (
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/default/regular"
            colorToken="colors/text/neutral"
            textAlignToken="text-alignment/center"
          >
            {`${feeAmount} ${feeTranslation}`}
          </Typography>
        </div>
      ) : (
        <div className="details-column-container" />
      )}

      <div className="details-column-container">
        <Typography
          accessibilityPreset="paragraph"
          textToken="text-style/text/paragraphs/default/regular"
          colorToken="colors/text/neutral"
          textAlignToken="text-alignment/end"
        >
          {`${totalTranslation} ${totalAmount}`}
        </Typography>
      </div>
    </div>
  </Fragment>
)

export default InvoicePaymentDetails
